import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

import '@angular/localize/init';

if (environment.production) {
  enableProdMode();
} else {
  console.info('🧪 Dev mode enabled');
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
